import React from "react";
import { Box, Typography, Button } from "@mui/material";

// Import the actual template components to be previewed
import QTemplate from "./QTemplate";
import InTemplate from "./InTemplate";

const TemplatePreview = ({ template, onConfirm, isAdmin }) => {
  let templateComponent;

  // Determine which component to render based on the template name
  if (template === "qtemplate") {
    templateComponent = <QTemplate />;
  } else if (template === "InTemplate") {
    templateComponent = <InTemplate />;
  } else {
    templateComponent = <Typography>No template selected for preview.</Typography>;
  }

  return (
    <Box mt={4}>
      <Typography variant="h5" gutterBottom>
        Template Preview
      </Typography>

      {/* Render the selected template component */}
      {templateComponent}

      {/* Only show the 'Confirm' button if the user is an admin */}
      {isAdmin && (
        <Button
          variant="contained"
          color="primary"
          onClick={onConfirm}
          sx={{ mt: 2 }}
        >
          Confirm Template
        </Button>
      )}
    </Box>
  );
};

export default TemplatePreview;